import React from 'react'
import { cn } from '@/lib/utils'
import { useAuthStore } from '@/store/auth'

interface UserAvatarProps {
  name?: string
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

export const UserAvatar: React.FC<UserAvatarProps> = ({ name, size = 'md', className }) => {
  const { user } = useAuthStore()

  const getInitials = (name: string) => {
    return (
      name
        ?.split(' ')
        ?.map(part => part[0])
        ?.join('')
        ?.toUpperCase()
        ?.slice(0, 1) || ''
    )
  }

  const sizes = {
    sm: 'h-8 w-8 text-sm',
    md: 'h-10 w-10 text-base',
    lg: 'h-12 w-12 text-lg'
  }

  return <div className={cn('rounded-full flex items-center justify-center bg-primary text-primary-foreground font-semibold ring-2 ring-primary/20 ring-offset-2 ring-offset-background', sizes[size], className)}>{getInitials(name || user?.name)}</div>
}
